import * as React from "react";
const SvgChartPie = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M36.392 34.96A9 9 0 0 1 41 33.054V43h9.945a9.002 9.002 0 1 1-14.553-8.04" />
      <path d="M45 39h5.488A9.03 9.03 0 0 0 45 33.512z" />
    </g>
  </svg>
);
export default SvgChartPie;
